export default __webpack_public_path__ + "static/media/soundwhite.f51e4b08.svg";